export default __webpack_public_path__ + "static/media/tuesday-saturday.e60d61c3.jpeg";